export const REINSTATE_BILL_DIALOG_ID = 'reinstateBillDialog';
